import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import StyledToastContainer from '../Style-guide/ToastMessage/style/StyledToastContainer';
import { GlobalStateProvider } from './globalState';
import LanguageSync from './languageSync';
import Router from './router';
import SessionGuard from './sessionGuard';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
      // refetchOnWindowFocus: false, /// responsible for query runs when switching between tabs(tab is focused)
      // useErrorBoundary: true,
    },
  },
});

const App = () => (
  <QueryClientProvider client={queryClient}>
    <GlobalStateProvider>
      <LanguageSync />
      <SessionGuard />
      <Router />
      <StyledToastContainer />
    </GlobalStateProvider>
  </QueryClientProvider>
);

export default App;
